/**
 * Hero arka plan videosu — geri dönmek için:
 * HERO_VIDEO_SRC = HERO_VIDEO_SRC_PREV  (10..mp4'e dön)
 *
 * CSS: frontend/src/index.css → .hero-video-wrap
 * Metin: frontend/src/pages/LandingPage.jsx → Hero()
 */

/** Aktif hero videosu (video/9.mp4) */
export const HERO_VIDEO_SRC = "/videos/hero-bg-9.mp4?v=9";

/** Bir önceki hero — geri dönmek için (video/10..mp4) */
export const HERO_VIDEO_SRC_PREV = "/videos/hero-bg-10.mp4?v=10";

/** Hakkımızda / preview kart videosu (video/infra3.mp4) */
export const ABOUT_VIDEO_SRC = "/videos/about-infra3.mp4?v=infra3";

/** Önceki hero videosu yedeği (InfraAI.mp4 kaynaklı) */
export const HERO_VIDEO_ORIGINAL = "/videos/hero-bg.original.mp4";

/** index.css — .hero-video-wrap video (orijinal ayarlar) */
export const HERO_VIDEO_CSS = {
  objectFit: "cover",
  objectPosition: "center center",
  filter: "saturate(1.05) contrast(1.04)",
  filterEnded: "saturate(1.08) contrast(1.05) brightness(0.92)",
  overlayPlaying: [
    "linear-gradient(to left, rgba(7,9,15,0.35) 0%, rgba(7,9,15,0.12) 28%, transparent 55%)",
    "linear-gradient(to bottom, rgba(7,9,15,0.18) 0%, transparent 45%, rgba(7,9,15,0.12) 100%)",
  ],
  overlayEnded: [
    "radial-gradient(ellipse 75% 60% at 50% 45%, rgba(7,9,15,0.28) 0%, rgba(7,9,15,0.06) 58%, transparent 78%)",
    "linear-gradient(to bottom, rgba(7,9,15,0.14) 0%, transparent 52%, rgba(7,9,15,0.16) 100%)",
  ],
};

/** LandingPage Hero — video davranışı (orijinal ayarlar) */
export const HERO_VIDEO_BEHAVIOR = {
  autoPlay: true,
  muted: true,
  playsInline: true,
  loop: false,
  pauseOnEnd: true,
  showTextOnEnd: true,
};
